module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAQCAYAAAAiYZ4HAAAAAXNSR0IArs4c6QAAAM1JREFUOE+N0jFKBEEQheGvQQwNnB1zA0/lAVRYTDQQ0cBoPMB6ABFMBQ+wYK4H0FQzVxBcQWWlZJARaXR7Kqx6/yuqX6dgITHTs9IjR4gpx6u8lbg0ocEe7rA1YDwP+g20usDZIjtLTP4Cc6DTPGG34jR9m/zUf0AnuAo2am67RglodR9B80yzxnsfoDM/H7DeB3jBQcVJ4rMEXCS2Kx5KN9wHw5rL/GnzDbNgFByuMC3lcB1s1tyUkt5PvC4zao8q/qUg5WnO3VByzOdfJABEEZHDcK8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/red-right-tag-icon.png
// module id = vpcI
// module chunks = 1